import template from './ArticleCardDetailed.vhtml';
import './ArticleCardDetailed.scss';

export default {
	name: 'ArticleCardDetailed',
	template,
	props: {
		imageUrl: {
			type: String,
			default: '',
		},
		url: {
			type: String,
			default: '',
		},
		noDescription: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		imageStyles() {
			return {
				backgroundImage: `url(${this.imageUrl})`,
			};
		},
	},
};
